import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const StockSummaryServices = {

  getList: async () => {
    const response = await apiService.get(`${slug}/stock-report/getstockitems`);
    return response.data;
  },

};

export default StockSummaryServices;
